import React, {useEffect, useState} from "react";
import {Col} from "antd";
import _ from "lodash";
import {FilterPropTypes} from "./ComponentPropTypes";
import {
    CityFilter,
    DatePickerWithPeriod,
    DayOffStatusFilter,
    SearchText
} from "../../_defaultComponents/FilterComponents";

const Filters = ({setCurrentPage, filters, setFilters}: FilterPropTypes) => {
    const [city, setCity] = useState(filters.city);
    const [period, setPeriod] = useState(filters.period);
    const [startDate, setStartDate] = useState(filters.startDate);
    const [endDate, setEndDate] = useState(filters.endDate);
    const [searchText, setSearchText] = useState(filters.searchText);
    const [approveStatus, setApproveStatus] = useState(filters.approveStatus);

    useEffect(() => {
        setCurrentPage(1);
    }, [city, period, startDate, endDate, searchText, approveStatus]);

    useEffect(() => {
        const newFilters = {city, period, startDate, endDate, searchText, approveStatus};
        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setFilters(newFilters);
        }
    }, [city, period, startDate, endDate, searchText, approveStatus]);

    return (
        <React.Fragment>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <CityFilter value={city} onChange={setCity} />
            </Col>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <DayOffStatusFilter
                    value={approveStatus}
                    onChange={setApproveStatus}
                    allowClear={false}
                />
            </Col>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <SearchText value={searchText} onChange={setSearchText} />
            </Col>
            <Col xs={24} sm={20} md={16} lg={10} xl={10}>
                <DatePickerWithPeriod
                    period={period}
                    setPeriod={setPeriod}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
            </Col>
        </React.Fragment>
    );
};

export default Filters;
